import React, { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import without from 'lodash/without';

import {
  FetchProductsFilters,
  ChangeProductsFiltersFunc
} from '../../../../../productsTypes';
import { GADataType } from '../../../../../../../types';

import { PureTooltipIconButtonHelper } from '../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { TooltipPlacement } from '../../../../../../../helpers/tooltips/tooltipsConstants';

import { ProductsListItemBrandNameFilterButtonProduct } from './ProductsListItemBrandNameFilterButton.types';

interface ProductsListItemBrandNameFilterButtonProps {
  product: ProductsListItemBrandNameFilterButtonProduct;
  productsFilters?: FetchProductsFilters;
  changeProductsFilters?: ChangeProductsFiltersFunc;
}

function ProductsListItemBrandNameFilterButton({
  dataGa,
  product,
  productsFilters,
  changeProductsFilters
}: ProductsListItemBrandNameFilterButtonProps & GADataType) {
  const brandId = product.brand?.id;

  const handleClick = useCallback<() => void>(() => {
    const currentBrandFilterIds = productsFilters?.brandId?.in || [];

    if (includes(currentBrandFilterIds, brandId)) {
      const currentBrandFilterIdsWithoutProductBrand = without(
        currentBrandFilterIds,
        brandId
      );
      changeProductsFilters?.(
        {
          brandId: { in: currentBrandFilterIdsWithoutProductBrand }
        },
        isEmpty(currentBrandFilterIdsWithoutProductBrand) ? ['brandId'] : null
      );
    } else {
      changeProductsFilters?.({
        brandId: { in: [...currentBrandFilterIds, brandId] }
      });
    }
  }, [brandId, productsFilters, changeProductsFilters]);

  if (!product.brand?.localizedName) {
    return null;
  }

  return changeProductsFilters ? (
    <PureTooltipIconButtonHelper
      className="focus:ring-offset-0 focus:ring-0 hover:opacity-80"
      dataGa={dataGa}
      icon={null}
      onClick={handleClick}
      text={product.brand.localizedName}
      tooltipPlacement={TooltipPlacement.BOTTOM}
      tooltipText={product.brand.localizedName}
    />
  ) : (
    <span>{product.brand.localizedName}</span>
  );
}

export default ProductsListItemBrandNameFilterButton;
